export function positionImages ($container) {
  'use strict'
  var imageAspect = 1 / 1,
    containersH = 0,
    containersW = 0
  // make sure container isn't position:static
  var containerPos = $container.css('position')
  $container.css({ 'overflow': 'hidden', 'position': (containerPos === 'static') ? 'relative' : containerPos })

  containersH = 0
  containersW = 0
  for (var i = 0, len = $container.length; i < len; i++) {
    var $this = $container.eq(i)
    imageAspect = $this.find('img').width() / $this.find('img').height()
    var outwrWidth = $this.outerWidth(),
      outerHeight = $this.outerHeight(),
      containerW = outwrWidth,
      containerH = outerHeight,
      containerAspect = containerW / containerH

    containersH += outerHeight
    containersW += outerHeight

    if (containerAspect < imageAspect) {
      // taller
      $this.find('img').css({
        position: 'relative',
        width: 'auto',
        height: containerH,
        top: 0,
        left: -parseInt((containerH * imageAspect - containerW) / 2)
      })
    } else {
      // wider
      $this.find('img').css({
        position: 'relative',
        width: containerW,
        height: 'auto',
        top: -parseInt((containerW / imageAspect - containerH) / 2),
        left: 0
      })
    }
  }
}
